import { JsonConverter, JsonCustomConvert } from 'json2typescript';

import { LegalSourceIncome } from '../../../../../core';

@JsonConverter
export class LegalSourceIncomeAdapter implements JsonCustomConvert<LegalSourceIncome | undefined> {
    serialize(source: LegalSourceIncome): any | undefined {
        return source ? String(source) : undefined;
    }

    deserialize(source: any): LegalSourceIncome | undefined {
        switch (source) {
            case '1D':
                return LegalSourceIncome.ACTIVITY;
            case '2D':
                return LegalSourceIncome.SALE;
            case '3D':
                return LegalSourceIncome.OTHER;
            default:
                return undefined;
        }
    }
}
